import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'VPanelRow',
  props: {
    label: { type: String, default: '' },
    labelRequired: { type: Boolean, default: false },
    labelSeparate: { type: Boolean, default: false },
    end: { type: Boolean, default: false },
    gap: { type: Boolean, default: false },
    first: { type: Boolean, default: false },
    padding: { type: Boolean, default: false },
    separator: { type: Boolean, default: false },
    separate: { type: Boolean, default: false },
    separateBottom: { type: Boolean, default: false },
    down: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
},
  setup(__props) {

// Other


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel__row", {
            'panel__row--first': __props.first,
            'panel__row--close-button': __props.first,
            'panel__row--padding': __props.padding,
            'panel__row--separator': __props.separator,
            'panel__row--separate': __props.separate,
            'panel__row--separate-bottom': __props.separateBottom,
            'panel__row--gap': __props.gap,
            'panel__row--end': __props.end,
            'panel__row--down': __props.down,
            'panel__row--center': __props.center,
        }])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["panel__label", {
                'required': __props.labelRequired,
                'panel__label--separate': __props.labelSeparate,
            }])
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})